import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './modules/shared/toast-container/toast-container.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor() {}
}
